import React from "react";
import "./PageLoadingStyles/PageLoadingStyles.scss";
import { WaveTopBottomLoading } from "react-loadingg";

const PageLoading = () => {
  return <WaveTopBottomLoading size={"large"} color="#0d47a1" />;
};

export default PageLoading;
